<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left" :style="{ visibility: render ? 'visible' : 'hidden' }">
        <select-cus @change="cusChange"/>
        <div class="date-picker-v2" :class="{ ml16: cusListTotal.length > 1 }">
          <el-date-picker
            class="query-date-picker"
            v-model="wageMonthRange"
            type="monthrange"
            format="yyyy-MM"
            value-format="yyyy-MM"
            :range-separator="$t('rangeSeparator')"
            :start-placeholder="$t('from')"
            :end-placeholder="$t('to')"
            @change="getData"
          />
        </div>
        <div class="select-v2">
          <el-select
            class="query-select"
            v-model="queryParams.idCards"
            multiple
            collapse-tags
            :placeholder="$t('selectStaff')"
            filterable
            clearable
            @change="handleSelectChange"
            @visible-change="handleSelectVisibleChange"
          >
            <el-option
              v-for="item in dictData.emp"
              :key="item.id"
              :value="item.idCard"
              :label="item.empName"
            />
          </el-select>
        </div>
        <div class="select-v2">
          <el-select
            class="query-select2"
            v-model="queryParams.idCards"
            multiple
            collapse-tags
            :placeholder="$t('selectCards')"
            filterable
            clearable
            @change="handleSelectChange"
            @visible-change="handleSelectVisibleChange"
          >
            <el-option
              v-for="item in dictData.emp"
              :key="item.id"
              :value="item.idCard"
              :label="item.idCard"
            />
          </el-select>
        </div>
      </div>
      <div class="title-right">
        <!--<span style="font-size: 12px; color: #FF0000;">-->
        <!--为了薪资证明文件美观性，建议显示项目不超过10项-->
        <!--</span>-->
        <el-button
          class="button-v2"
          type="primary"
          :loading="submitLoading"
          @click="handleProofDownload"
        >
          {{ $t('incomeProof') }}
        </el-button>
        <el-button
          class="button-v2"
          plain
          @click="customHeaderModalShow = true"
        >
          {{ $t('displayItemConfiguration')}}
        </el-button>
        <el-button
          class="button-v2"
          type="primary"
          :loading="submitLoading"
          @click="handleExport"
        >
          {{ $t('export') }}
        </el-button>
        <!--<el-button class="button-v2" :loading="submitLoading" @click="handleProofDownloadTask">{{ $t('zipdownloadTask') }}</el-button>-->
      </div>
    </div>
    
    <div class="table-body flex vertical" v-loading="loading">
      <air-table
        ref="airTable"
        class="table-v2"
        :show-checkbox="true"
        :show-operation="false"
        align="center"
        :columns="columns"
        :data="tableData"
        show-footer
        :footer-method="footerMethod"
        @checkbox-change="check"
        @checkbox-all="check"
        @change-filter="changeFilter"
      />
      <bsp-pagination
        :pager-config.sync="queryParams"
        @page-change="getData"
        @page-size-change="pageSizeChange"
        show-page-size
      />
    </div>
    
    <el-dialog
      class="modal-v2 has-padding"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('displayItemConfiguration')"
      v-if="customHeaderModalShow"
      :visible.sync="customHeaderModalShow"
      append-to-body
    >
      <div class="color-primary pb10 text-left">{{$t('cusHeadRemark')}}</div>
      <customHeader
        :header-list.sync="headerList"
        :paramFromSyn.sync="paramFromSyn"
        report-type="员工薪资收入证明表"
      />
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button
          plain
          class="button-v2"
          @click="customHeaderModalShow = false"
        >
          {{ $t('cancel') }}
        </el-button>
        <el-button
          type="primary"
          class="button-v2"
          :loading="submitLoading"
          @click="saveCustomHeader"
        >
          {{ $t('save')
          }}
        </el-button>
      </div>
    </el-dialog>
    <!-- dialog 新增 编辑 弹窗 -->
    <el-dialog
      class="modal-v2 has-padding"
      title="薪资证明下载"
      width="60%"
      :visible.sync="showDownload"
      :close-on-click-modal="false"
      append-to-body
      @closed="downloadModalClosed"
    >
      <div class="flex jbetween">
        <div class="font-18 fw-600">{{ $t('incomeProof1')}}</div>
        <div class="title-right flex acenter">
          <el-button class="button-v2" plain @click="customHeaderModalShow = true">{{ $t('displayItemConfiguration')}}</el-button>
          <el-dropdown class="ml10" placement="bottom">
            <el-button class="button-v2" type="primary">{{ $t('createProofAndDownload') }}</el-button>
            <el-dropdown-menu slot="dropdown" class="dropdown-menu">
              <el-dropdown-item>
                <el-button class="button-v2" type="primary" @click="downloadFile(1)">{{ $t('downloadWordType') }}</el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button class="button-v2" type="primary" @click="downloadFile(2)">{{ $t('downloadPdfType') }}</el-button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown class="ml10" placement="bottom">
            <el-button class="button-v2" type="primary">{{ $t('createEachAndDownload') }}</el-button>
            <el-dropdown-menu slot="dropdown" class="dropdown-menu">
              <el-dropdown-item>
                <el-button class="button-v2" type="primary" @click="downloadFile(3)">{{ $t('downloadWordType') }}</el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button class="button-v2" type="primary" @click="downloadFile(4)">{{ $t('downloadPdfType') }}</el-button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    
      <!-- 输入框 -->
      <el-input
        class="textarea-v2 mt20"
        type="textarea"
        :rows="3"
        placeholder="请输入内容"
        v-model="form.templateStart"
      />
    
      <!-- 展示表格 -->
      <div class="table-body mt20" v-loading="loading" style="height: 400px;" >
        <air-table
          ref="airTableDetail"
          class="table-v2"
          :show-checkbox="false"
          :show-operation="false"
          align="center"
          :columns="columns"
          :data="detailTableData"
          show-footer
          :footer-method="footerMethod"
          :remote="false"
        />
      </div>
    
      <!-- 另一个输入框 -->
      <el-input
        class="textarea-v2 mt30"
        type="textarea"
        :rows="3"
        placeholder="请输入内容"
        v-model="form.templateEnd"
      />
    </el-dialog>
  </div>
</template>

<script>
  import * as api from '@/api/wage/payslip'
  import {queryEmpInfoListPage} from '@/api/v2/common'
  import exportMethod from '@/util/export'
  import customHeader from '@/components/v2/custom-header'
  import SelectCus from '@/views/v2/stats/data-center/components/Common/SelectCus';
  import {updataCustHeaderInfo} from '@/api/wage/pay'
  import {downloadFileByUrl} from '@/util/util';
  import {randomLenNum} from '@/util/util';
  import {floatSumArray} from '@/util/util';
  import {validatenull} from '@/util/validate';
  import {mapGetters} from 'vuex';
  import Moment from "moment";

  export default {
    name: 'EmpIncomeDetail',
    components: {
      customHeader,
      SelectCus
    },
    data() {
      return {
        render: false,
        loading: true,
        wageMonthRange: [
          Moment(new Date()).format("YYYY-MM"),
          Moment(new Date()).format("YYYY-MM")
        ],
        isSelectChange: false,
        queryParams: {
          isProofOfIncomePage: '10020001',
          startDate: undefined,
          endDate: undefined,
          idCards: [],
          salaryDetailIds: [],
          detailId: '',
          costCenters: [],
          taxTypes: [],
          // wageMonths: [],
          cusIds: [],
          page: 1,
          limit: 20,
          total: 0
        },
        downloadpdfParams: {},
        limitCustom: 1,
        dictMap: {},
        dictData: {
          emp: [],
          costCenter: [],
          taxType: []
        },
        columns: [],
        tableData: [],
        detailTableData: [],
        submitLoading: false,
        customHeaderModalShow: false,
        headerList: [],
        checkedList: [],
        paramFromSyn:{isProofOfIncomePage: '10020001'},
        showDownload: false,
        showDownloadOptions: false,
        showDownloadOptions2: false,
        params: {},
        form: {},
      }
    },
    computed: {
      ...mapGetters(['cusListTotal'])
    },
    created() {
      const storeParams = this.$getStore('empIncomeDetail_queryParams');
      if (storeParams) {
        // 如果缓存中有参数，则说明是从汇总点击查看明细而来
        this.queryParams = storeParams;
        this.$removeStore('empIncomeDetail_queryParams');
      }
      this.init();
    },
    methods: {
      init() {
        this.queryParams.cusId = this.$userInfo.cusId;
        this.getEmpList();
        this.getData();
      },
      getData(val) {
        this.queryParams.salaryDetailIds = [];
        this.checkedList=[];
        this.render = false;
        this.loading = true;
        if (this.$isNotEmpty(this.wageMonthRange)) {
          this.queryParams.startDate = this.wageMonthRange[0];
          this.queryParams.endDate = this.wageMonthRange[1];
        } else {
          this.queryParams.startDate = undefined;
          this.queryParams.endDate = undefined;
        }
        api.selectDataForSalaryDetail(this.queryParams).then(res => {
          const data = res.data.data;
          data.customList.forEach(item => {
            item.minWidth = 140;
            if (item.field === 'empName' || item.field === 'identityNum' || item.field === 'idCard') {
              item.fixed = 'left';
              item.filterType = 'input';
            }
          });
          this.columns = data.customList;
          data.translates.forEach(item => {
            if (item.dictMap != undefined) {
              this.dictMap[item.field] = this.$arrayToObj(item.dictMap, 'codeItemId');
            }
          });
          if (!this.dictMap.taxType) {
            this.dictMap.taxType = this.$arrayToObj(data.taxType, 'codeItemId');
          }
          this.tableData = this.$handleTableDict(data.dataList, this.dictMap, '');
          if(this.queryParams.total != data.params.total&&this.queryParams.page!=1){
            this.queryParams.page=1;
            this.getData(val);
          }
          this.queryParams.total = data.params.total;
          this.dictData.costCenter = data.costCenter;
          this.dictData.taxType = data.taxType;
          this.render = true;
          this.loading = false;
        })
      },
      getTemplate(val) {
        // this.render = false;
        this.loading = true;
        this.params.cusId = this.queryParams.cusId;
        api.getSysProofIncomeTemp(this.params).then(res => {
          if (res.data) {
            if (res.data.data) {
              var msgBody = res.data.data.msgBody;
              let msgBodys = msgBody.split("<数据>");
              this.form = {
                templateStart: msgBodys[0],
                templateEnd: msgBodys[1]
              }
            } else {
              this.form = {
                templateStart: '',
                templateEnd: ''
              }
            }
          } else {
            this.form = {
              templateStart: '',
              templateEnd: ''
            }
          }
          this.loading = false;
        })
      },
      changeFilter(e) {
        this.queryParams = {...this.queryParams, ...e.filterData};
        this.getData();
      },
      check({records}) {
        this.checkedList = records;
      },
      getEmpList() {
        queryEmpInfoListPage({cusId: this.$userInfo.cusId, limit: 100000}).then(res => {
          this.dictData.emp = res.data.records;
        })
      },
      handleSelectChange(val) {
        if (this.$isEmpty(val)) {
          // 如果val为空数组，则说明触发了清空，此时不会触发visible-change事件，需要手动查询后端
          this.getData();
          this.isSelectChange = false;
        } else {
          this.isSelectChange = true;
        }
      },
      handleSelectVisibleChange(val) {
        // 多选的blur无法触发，而change事件触发又过于频繁，因此此处使用visible-change，即多选后下拉框消失才会查询后端数据
        if (!val && this.isSelectChange) {
          this.getData();
          // 为了防止查询条件未变化时下拉框消失也查询后端，用此标识来记录select是否有变化，并在此处重置
          this.isSelectChange = false;
        }
      },
      saveCustomHeader() {
        if (this.$isEmpty(this.headerList)) {
          this.$msgError(`${this.$t('noEmptyColumn')}`);
          return;
        }
        ;
        let param = {
          headers: this.headerList,
          isProofOfIncomePage: '10020001',
          reportType: '员工薪资收入证明表'
        };
        this.submitLoading = true;
        updataCustHeaderInfo(param).then(res => {
          if (res.data.code === 0) {
            this.customHeaderModalShow = false;
            this.$msgSuccess(`${this.$t('successTips')}`);
            this.getData();
          }
        }).finally(() => this.submitLoading = false);
      },
      handleExport() {
        this.$msgInfo(`${this.$t('startDownloading')}...`);
        this.queryParams.salaryDetailIds = this.checkedList.map(item => item.id);
        exportMethod({
          columns: this.$clone(this.columns),
          beanName: 'salaryHistoryServiceImpl',
          methodName: 'selectDataForSalaryDetailForExport',
          headerType: '1003',
          headerRowNum: 1,
          isSort: true,
          fileName: "员工薪资收入证明表.xls",
          ...this.queryParams,
          type: 'excel'
        }, '/wage', true)
      },
      handleProofDownload() {
        this.queryParams.salaryDetailIds = this.checkedList.map(item => item.id);
        if (this.queryParams.salaryDetailIds.length > 0) {
          //根据salaryDetailIds，过滤选中数据
          this.detailTableData = this.$clone(this.checkedList);
          this.showDownload = true;
        } else {
          this.$msgError(`${this.$t('pleaseSelectPaidResultRow')}`);
        }
        //调用查询接口，回显模板
        this.getTemplate();
      },
      // 客户筛选change事件
      cusChange({data, checkedLabels, checkedValues}) {
        this.queryParams.cusIds = checkedValues;
        this.getData();
      },
      numToArray(list, field) {
        return list.map(item => {
          return validatenull(item[field]) ? 0 : item[field];
        })
      },
      sumNum(list, field) {
        const numArray = this.numToArray(list, field);
        return floatSumArray(numArray);
      },
      footerMethod({columns, data}) {
        let _this = this;
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            } else {
              if (!validatenull(column.params)) {
                const {valueType} = column.params;
                if (valueType == '92420001' || valueType == '92420002') {
                  return this.sumNum(data, column.property);
                }
                return null
              } else {
                return null
              }
            }
          })
        ]
      },
      // 输入框回车，调接口
      pageSizeChange(val) {
        this.queryParams = Object.assign(val);
        this.getData();
      },
      downloadpdfOnSingal(item) {
        this.downloadpdfParams.empId = item.empId;
        this.downloadpdfParams.month = item.wageMonth;
        this.downloadpdfParams.cusId = item.cusId;
        this.downloadpdfParams.idCard = item.idCard;
        let fileId = '';
        api.downloadPdf(this.downloadpdfParams).then(res => {
          fileId = res.data.fileId;
          downloadFileByUrl('/api/file/' + fileId, item.empName.replace("*", '') + item.idCard.replace("*", '') + '_' + item.wageMonth + '.pdf')
        })
      },
      showProjectSettings() {
        // 显示项目设置的逻辑
      },
      downloadFile(type) {
        //保存模板
        this.params.cusId = this.queryParams.cusId;
        this.params.msgBody = this.form.templateStart + '<数据>' + this.form.templateEnd;
        if (this.$isNotEmpty(this.wageMonthRange)) {
          this.queryParams.startDate = this.wageMonthRange[0];
          this.queryParams.endDate = this.wageMonthRange[1];
        } else {
          this.queryParams.startDate = undefined;
          this.queryParams.endDate = undefined;
        }
        let fileId = '';
        api.saveSysProofIncomeTemp(this.params).then(res => {
          if (res.data) {
            if (res.data.data) {
              var msgBody = this.params.msgBody;
              let msgBodys = msgBody.split("<数据>");
              this.form = {
                templateStart: msgBodys[0],
                templateEnd: msgBodys[1]
              }
            } else {
              this.form = {
                templateStart: '',
                templateEnd: ''
              }
            }
          } else {
            this.form = {
              templateStart: '',
              templateEnd: ''
            }
          }
          this.loading = false;
          if (type === 1) {
            // 合并下载word版本的逻辑
            api.downloadWordProofAllInOne(this.queryParams).then(res => {
              let randomNum = randomLenNum("16",new Date());
              fileId = res.data.downloadPath;
              if (fileId) {
                downloadFileByUrl(fileId, randomNum + '.zip')
              }
            });
            this.showDownloadOptions = false;
          } else if (type === 2) {
            // 合并下载PDF版本的逻辑
            api.downloadPdfProofAllInOne(this.queryParams).then(res => {
              let randomNum = randomLenNum("16",new Date());
              fileId = res.data.downloadPath;
              if (fileId) {
                downloadFileByUrl(fileId, randomNum + '.zip')
              }
            });
          } else if (type === 3) {
            // 单个下载word版本的逻辑
            api.downloadWordProof(this.queryParams).then(res => {
              let randomNum = randomLenNum("16",new Date());
              fileId = res.data.downloadPath;
              if (fileId) {
                downloadFileByUrl(fileId, randomNum + '.zip')
              }
            });
          } else if (type === 4) {
            // 单个下载PDF版本的逻辑
            api.downloadPdfProof(this.queryParams).then(res => {
              let randomNum = randomLenNum("16",new Date());
              fileId = res.data.downloadPath;
              if (fileId) {
                downloadFileByUrl(fileId, randomNum + '.zip')
              }
            });
          }

        });
      },
      downloadModalClosed() {
        this.$refs.airTableDetail.$refs.table.resetFilterEvent()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/air/assets/css/main.scss";
  .query-select2 {
    width: 240px;
    margin-right: 16px;

    ::v-deep .el-tag--small {
      height: 20px;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .menuTop {
    border-bottom: 4px solid #eee;
    padding: 0 20px;
  }

  .menuCon {
    padding: 0 20px;
  }

  .menuCon p {
    font-size: 12px;
    font-weight: 400;
    color: rgba(252, 106, 106, 1);
    line-height: 17px;
    padding-top: 100px;
    padding-bottom: 8px;
  }
</style>
